import {translations} from 'presentation/translations-new';
import {Theme} from '@mui/material';
import {formatText} from 'presentation/utils';
import {AuthorizationStatusEnum} from './authorizationStatus';

const {status: statusCard} = translations['pt-br'].privateFlow.requestAuthorizations;

export type Status =
	| 'todos'
	| 'liberado'
	| 'pendente'
	| 'indeferido'
	| 'registrado'
	| 'concluido'
	| 'em analise';

type CardStyleByStatusType = {
	[key in Status]: {
		borderColor: string;
		chipVariant: 'primary' | 'success' | 'error' | 'warning' | 'info' | 'default';
		chipText: string;
		chipTextColor?: string;
		chipBackgroundColor?: string;
	};
};

export const cardStyleByStatus = (theme: Theme, status: Status) => {
	const styles: CardStyleByStatusType = {
		[AuthorizationStatusEnum.SUCCESS]: {
			borderColor: theme.palette.success.main,
			chipVariant: 'success',
			chipText: statusCard.success,
			chipTextColor: theme.colors.light.success.dark,
		},
		[AuthorizationStatusEnum.REJECTED]: {
			borderColor: theme.colors.light.error.dark as string,
			chipVariant: 'error',
			chipText: statusCard.rejected,
			chipTextColor: theme.colors.light.error.dark,
		},
		[AuthorizationStatusEnum.PENDING]: {
			borderColor: theme.colors.light.warning.main as string,
			chipVariant: 'warning',
			chipText: statusCard.pending,
			chipTextColor: theme.colors.light.warning.dark,
		},
		[AuthorizationStatusEnum.REGISTERED]: {
			borderColor: theme.palette.text.disabled,
			chipVariant: 'default',
			chipText: statusCard.registered,
		},
		[AuthorizationStatusEnum.FINISHED]: {
			borderColor: theme.palette.success.main,
			chipVariant: 'success',
			chipText: statusCard.finished,
			chipTextColor: theme.colors.light.success.dark,
		},
		[AuthorizationStatusEnum.ALL]: {
			borderColor: theme.palette.text.disabled,
			chipVariant: 'success',
			chipText: statusCard.finished,
			chipTextColor: theme.colors.light.success.dark,
		},
		[AuthorizationStatusEnum.UNDER_ANALYSIS]: {
			borderColor: theme.colors.light.primary['30Percent'] as string,
			chipVariant: 'info',
			chipText: statusCard.underAnalysis,
			chipTextColor: theme.colors.light.primary['190Percent'] as string,
			chipBackgroundColor: theme.colors.light.primary['30Percent'] as string,
		},
	};

	const defaultStyles = {
		borderColor: theme.palette.text.disabled,
		chipVariant: 'default' as const,
		chipText: formatText(status),
	};

	return styles[status] || defaultStyles;
};
